import { c as _c } from "react/compiler-runtime";
import { CreateTeamDialog } from "@pages/members/teams/create-team-dialog";
import { useCompanyId } from "@context-providers/company-id-provider";
import { TEAM_DISPLAY_NAME } from "@src/constants/team-constants";
import { TeamEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useState } from "react";
import { useTeamsAccess } from "@hooks/access-control/use-teams-access";
import { useMediaQueryList } from "@hooks/use-media-query";
import { Button } from "@flat-ui";

/** Renders the create button and dialog to create team */
export function CreateTeam(t0) {
  const $ = _c(15);
  const {
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "secondary" : t1;
  const companyId = useCompanyId();
  const {
    trackEvent
  } = useTrackEvent();
  const {
    isScreenSmOrSmaller
  } = useMediaQueryList();
  const {
    canCreateNewTeam
  } = useTeamsAccess();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  let t2;
  if ($[0] !== trackEvent) {
    t2 = function onOpenDialog() {
      trackEvent({
        name: TeamEvents.startCreateNewTeam
      });
      setIsDialogOpen(true);
    };
    $[0] = trackEvent;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const onOpenDialog = t2;
  if (!canCreateNewTeam) {
    return null;
  }
  const t3 = isScreenSmOrSmaller ? "primary" : variant;
  const t4 = isScreenSmOrSmaller ? "100%" : "auto";
  let t5;
  if ($[2] !== t4) {
    t5 = {
      width: t4
    };
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== onOpenDialog || $[5] !== t3 || $[6] !== t5) {
    t6 = <Button variant={t3} onClick={onOpenDialog} sx={t5}>New {TEAM_DISPLAY_NAME}</Button>;
    $[4] = onOpenDialog;
    $[5] = t3;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setIsDialogOpen(false);
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== companyId || $[10] !== isDialogOpen) {
    t8 = <CreateTeamDialog companyId={companyId} isDialogOpen={isDialogOpen} onCloseDialog={t7} />;
    $[9] = companyId;
    $[10] = isDialogOpen;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t6 || $[13] !== t8) {
    t9 = <>{t6}{t8}</>;
    $[12] = t6;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}